import { useAppStore } from '@/store'

// Desktop CTA, bottom-right above the dock line — the spot the vanilla UI
// established. Phones get the same action from the MobileBar instead.
export function RegisterCta() {
  const walking = useAppStore((s) => s.walking)
  const setRegisterOpen = useAppStore((s) => s.setRegisterOpen)

  if (walking) return null

  return (
    <div className="pointer-events-none fixed right-6 bottom-6 z-50 hidden flex-col items-end gap-2 sm:flex">
      <span className="glass-pill pointer-events-auto px-3 py-1.5 text-xs font-medium">
        Interested in a residence?
      </span>
      <button
        type="button"
        onClick={() => setRegisterOpen(true)}
        className="bg-primary text-primary-foreground rounded-control pointer-events-auto cursor-pointer px-5 py-3 text-sm font-semibold shadow-lg shadow-black/20 transition-opacity hover:opacity-90"
      >
        Register interest
      </button>
    </div>
  )
}
